import { GridRowSelectionModel } from '@mui/x-data-grid-premium'
import * as React from 'react'
import { FooterRendererProps, TasksGridFooterProps } from 'types'
import GlobalDataGridFooter from './GlobalDataGridFooter'

type FooterOutletProps = FooterRendererProps & {
  TaskFooter?: React.ComponentType<TasksGridFooterProps>
  taskFooterProps?: any
  globalFooterProps: {
    filterModel: any
    setFilterModel: (_updater: any) => void
    selectedRowCount: number
    rowSelectionModel: GridRowSelectionModel
    setRowSelectionModel: React.Dispatch<React.SetStateAction<GridRowSelectionModel>>
    serverSideMode: boolean
    onClearFilters?: () => void
    onFilterModelChange?: (newFilterModel: any) => void
    monthFilter?: string
    onChangeMonth?: (month: string) => void
  }
}

const FooterOutlet: React.FC<FooterOutletProps> = React.memo(
  ({ rowSelectionModel, setRowSelectionModel, TaskFooter, taskFooterProps, globalFooterProps }) => {
    const hasSelection = rowSelectionModel?.ids?.size > 0

    // Show TaskFooter (mass update panel) only when rows are selected
    const showTaskFooter = hasSelection && TaskFooter

    // Show GlobalDataGridFooter (filters, row counts, pagination) when no selection
    // This applies to both server-side and client-side modes
    const showGlobalFooter = !hasSelection

    return (
      <>
        {/* Custom/Selection footer – shows when rows are selected */}
        {showTaskFooter ? (
          <TaskFooter
            rowSelectionModel={rowSelectionModel}
            setRowSelectionModel={setRowSelectionModel}
            {...taskFooterProps}
          />
        ) : null}

        {/* Global footer – shows when no selection (filters, pagination, row counts) */}
        {showGlobalFooter ? <GlobalDataGridFooter {...globalFooterProps} /> : null}
      </>
    )
  }
)

export default FooterOutlet
